(() => {
  const openPreferences = () => {
    if (window.privacyBanner?.showPreferences) {
      window.privacyBanner.showPreferences();
      return true;
    }

    if (window.Shopify?.customerPrivacy?.showPreferences) {
      window.Shopify.customerPrivacy.showPreferences();
      return true;
    }

    return false;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wh-cookie-preferences]');
    if (!button) return;
    event.preventDefault();

    if (openPreferences()) return;

    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        () => openPreferences(),
      );
    }
  });
})();
